<template>
    <integration-gmail is-onboarding-integration/>
</template>

<script>
import {defineComponent} from 'vue'
import IntegrationGmail from "../../settings/integrations/IntegrationGmail.vue";

export default defineComponent({
  name: "OnboardingStepGmail",
  components: {IntegrationGmail},
})
</script>

<style scoped lang="scss">

</style>
